import axios from "axios";

const fetchAddressSuggestions = async (query, countryCode = "") => {
  if (query.length < 3) return [];

  try {
    const response = await axios.get(
      "https://nominatim.openstreetmap.org/search",
      {
        params: {
          q: query,
          countrycodes: countryCode,
          format: "json",
          addressdetails: 1,
          limit: 10,
        },
        headers: {
          "Accept-Language": "en",
          "User-Agent": "SVaaNGlobalTech (admin@svaantech.com)", // replace with your email
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching address suggestions:", error);
    return [];
  }
};

export default fetchAddressSuggestions;
